module.exports = __webpack_public_path__ + "static/planet-google-9793f4dbed8be3cba188054be89dd038.jpg";